<template>
  <div class="screen-score-detail" :class="{'filter-blur':activitymoadal==true}">
    <div class="head-wra">
      <span class="back" @click="goBack(model.evaluationStatus)">&lt;{{ $t("system.back") }}</span>
      <div class="info clearfix" :class="{isStudent:model.type == 1}">
        <img
          class="student-headImg"
          :src="getImg(model.headImage)"
          alt="student"
          v-if="model.type == 1"
        />
        <span class="name ellipsis-one" :class="{'noheadImg':model.type != 1}">{{model.name}}</span>
      </div>
      <span>{{model.score}}</span>
      <span class="score">{{$t("grade.points", { n: model.score > 0 || model.score === 0 ? model.score : '--' })}}</span>
    </div>
    <div class="score-list-wra">
      <div class="tab" :class="{isNotMark:showTab == 2}">
        <span class="marked" @click="changeTab(1)">
          {{ $t("grade.evaluated") }}
          <b>{{model.classScoreMarks?model.classScoreMarks.length:0}}</b>
        </span>
        <div class="changeTab"></div>
        <span class="notMark" @click="changeTab(2)">
          {{ $t("grade.unevaluated") }}
          <b>{{model.noMarkScores?model.noMarkScores.length:0}}</b>
        </span>
      </div>
      <span
        class="endScore-btn"
        @click="changeMarked"
      >{{model.evaluationStatus == 1 ? $t("grade.startEva") : $t("grade.stopEva")}}</span>
      <p
        class="empty"
        v-if="(showTab == 1 &&　model.classScoreMarks && model.classScoreMarks.length <= 0) || (showTab == 2 &&　model.noMarkScores && model.noMarkScores.length <= 0)"
      >{{showTab == 1 ? $t("grade.noEva") : $t("grade.noUneva")}}</p>
      <ul class="score-list clearfix" v-scrollBar>
        <li class="score-item clearfix" v-for="(item,index) in list" :key="'mark' + index">
          <div class="info">
            <img class="student-headImg" :src="getImg(item.headImage)" alt="student" />
            <span class="name ellipsis-one">{{item.userName}}</span>
          </div>
          <span
            class="score"
          >{{$t("grade.points", { n: item.score > 0 || item.score === 0 ? item.score : '--' })}}</span>
        </li>
      </ul>
    </div>
    <div class="over-modal" v-if="isShowModal">
      <div class="over-wraper">
        <div class="over-title">{{ $t("system.remind") }}</div>
        <div class="text">{{ $t("grade.tip8") }}</div>
        <div class="operation">
          <button class="sure" @click="changeMarkedEnd(1)">{{ $t("system.confirm") }}</button>
          <button class="cancel" @click="cancel">{{ $t("system.cancel") }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventHandler from "../../common/js/EventHandler";
export default {
  name: "score",
  props: {
    activitymoadal: Boolean
  },
  data() {
    return {
      userId: 0,
      scoreId: 0,
      selectId: this.$route.params.id,
      model: {},
      list: [],
      activityModel: {},
      showTab: 1,
      isShowModal: false
    };
  },
  methods: {
    getDetail() {
      var self = this;
      this.timer = setInterval(function() {
        self.getModel();
      }, 2000);
    },
    getScoreDetail() {
      var self = this;
      self.$http
        .get(
          `${self.baseURL1}/classscore/getDetail?userId=${self.userId}&id=${self.scoreId}&roleId=9`
        )
        .then(res => {
          self.activityModel = res.data;
          self.$emit("pushDetial", res.data);
        });
    },
    getModel() {
      const self = this;
      let showTab = self.showTab;
      self.$http
        .get(
          `${self.baseURL1}/classscore/getEvaluationForPersonal?selectId=${self.selectId}`
        )
        .then(res => {
          self.model = res.data;
          self.$set(self.activityModel, "title", res.data.title);
          self.$set(self.activityModel, "status", res.data.activityStatus);
          self.$emit("pushDetial", self.activityModel);
          if (showTab == self.showTab) {
            //防止慢的覆盖快的
            if (self.showTab === 1) {
              self.list = res.data.classScoreMarks;
            } else {
              self.list = res.data.noMarkScores;
            }
          }
        });
    },
    getImg(imgUrl) {
      return this.common.handleImg(imgUrl, this.rescourceURL);
    },
    changeTab(tabIndex) {
      this.list = [];
      this.showTab = tabIndex;
      this.getModel();
    },
    changeMarked() {
      if (this.model.evaluationStatus != 1) {
        this.isShowModal = true;
      } else {
        this.changeMarkedEnd(0);
      }
    },
    changeMarkedEnd(status) {
      const self = this;
      self.$http
        .post(
          `${this.baseURL1}/classscore/updateEvaluationForPersonal?selectId=${this.selectId}&status=${status}`
        )
        .then(res => {
          self.isShowModal = false;
          if (status == 1) {
            self.$Message.success(this.$t("grade.tip9"));
          }
          self.getModel();
        });
    },
    cancel() {
      this.isShowModal = false;
    },
    goBack(status) {
      if (status == 1) {
        this.$router.replace(`/screenIndex/scoreEndList`);
      } else {
        this.$router.replace(`/screenIndex/score`);
      }
    },
    _changeTab(param) {
      if (param == 1) {
        this.changeTab(2);
      } else {
        this.changeTab(1);
      }
    }
  },
  created: function() {
    EventHandler.bindEvent("changeTab", this._changeTab);
    EventHandler.bindEvent("goBack", this.goBack);
    this.userId = this.common.getCookie("userId");
    this.scoreId = this.common.getCookie("activityId");
    this.getModel();
  },
  computed: {},
  watch: {},
  mounted: function() {},
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "scoreDetail.scss";
</style>



// WEBPACK FOOTER //
// src/components/scoreDetail/scoreDetail.vue